module.exports = __webpack_public_path__ + "static/media/isotop_1.6beca413.jpeg";